$(document).ready(function(){var n=$(".hamburger");n.on("click",function(c){n.toggleClass("is-active")})});